module.exports = __webpack_public_path__ + "img/notice.f931c837.jpeg";